import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-chip', 'close', 'Close');
